/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable no-debugger */
import { all, put, select, takeEvery, call } from 'redux-saga/effects';
import { GET_MY } from '../../containers/App/constants';
import { getMy } from '../Api/saga';
import {
  fetchKanbanBoardColumnCells,
  fetchKanbanBoardColumnCellsFiltered,
  fetchKanbanBoards,
  setProgressBarValue,
} from './actions';
import {
  APPLY_KANBAN_FILTERS,
  RESET_ALL_KANBAN_FILTERS,
  GET_KANBAN_BOARDS,
  KANBAN_BOARDS_REFRESH,
  PREPARE_KANBAN_PROGRESS_BAR,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_NEXT,
} from './constants';
import {
  selectActiveKanbanBoardId,
  selectKanbanBoardRequestQueue,
  selectKanbanBoardRequestQueueActive,
  selectKanbanBoard,
  selectKanbanBoardColumnCells,
  selectKanbanBoardColumnDirty,
  selectKanbanBoards,
  selectKanbanFilter,
} from './selectors';
import { FILTER_DEFAULT_LIMIT, REQUEST_VEHICLES } from '../Vehicles/constants';

// per-column retry counters for dirty re-fetches
const columnRefetchRetries = {};

function* refreshBoards() {
  let boards = yield select(selectKanbanBoards());
  if (!boards || !boards.length) yield put(fetchKanbanBoards());
  let active = yield select(selectActiveKanbanBoardId());

  let called = false;
  let tries = 5;
  while (--tries > 0 && !(yield select(selectKanbanBoards())).length) {
    if (!called) {
      yield put(fetchKanbanBoards());
      called = true;
    }
    yield new Promise(resolve => setTimeout(resolve, 600));
  }

  let board = yield select(selectKanbanBoard(active));

  for (let i = 0; i < board?.columns.length; i++) {
    const col = board.columns[i];

    yield put(fetchKanbanBoardColumnCells(board.id, col.id));
  }
}

function* requestKanbanColumnCells({ callback, boardId, columnId, limit }) {
  //mov

  if (!limit) debugger;

  let action = {
    type: GET_MY,
    id: REQUEST_KANBAN_BOARD_COLUMN_CELLS,
    boardId,
    columnId,
    work: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    gate: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + columnId,
    path: `boards/${boardId}/columns/${columnId}/cells?offset=0&limit=${limit}`,
    callback,
  };

  yield put({
    type: REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD,
    action,
  });
}

function* requestKanbanFilter({ type }) {
  let filterString = '';
  console.log(type);
  if (type === APPLY_KANBAN_FILTERS) {
    let filter = yield select(selectKanbanFilter());
    let offset = filter.offset || 0;
    let limit = filter.limit || FILTER_DEFAULT_LIMIT;
    let text = filter.searchString || null;
    const sortType = filter?.sortType;
    const order = filter?.order;

    const filters = filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f));

    for (let i = 0; i < filters?.length; i++) {
      filterString += `&filters[${i}][key]=${filters[i].key}&filters[${i}][type]=${filters[i].type}&${filters[i].value
        .map((val, index) => `filters[${i}][value][${index}]=${filters[i].value[index]}`)
        .join('&')}`;
    }
    // change if use offset or limit first
    if (text) filterString += `&text=${text}`;
    filterString = '?' + filterString.slice(1);
  }

  // let searchParams = {
  //   offset,
  //   limit,
  //   text: text ?? undefined,
  //   filters: filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  // };
  //
  // if (!!sortType) {
  //   searchParams.sortType = sortType;
  //   searchParams.order = order ?? 'desc';
  // }

  let boardId = yield select(selectActiveKanbanBoardId());
  let board = yield select(selectKanbanBoard(boardId));
  let columnIds = board?.columns?.map(c => c.id);
  let paths = columnIds?.map(cid => `/boards/${boardId}/columns/${cid}/cells/from-cache${filterString}`);

  for (let i = 0; i < board?.columns?.length; i++) {
    const col = board.columns[i];

    yield put({
      type: GET_MY,
      id: REQUEST_KANBAN_BOARD_COLUMN_CELLS,
      boardId,
      columnId: col.id,
      work: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + col.id,
      gate: REQUEST_KANBAN_BOARD_COLUMN_CELLS + boardId + '_' + col.id,
      path: paths[i],
      putOnComplete: [
        {
          type: REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK,
          boardId,
          columnId: col.id,
        },
      ],
    });
  }
}

function* requestKanbanColumnCellsNext({ callback, boardId, columnId, limit }) {
  let active = yield select(selectKanbanBoardRequestQueueActive());

  if (active && new Date().getTime() > active?.startedAt + 5000) {
    debugger;
    active = null;
  }
  if (active) return;

  let queue = yield select(selectKanbanBoardRequestQueue());

  yield put({
    type: REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE,
  });

  active = yield select(selectKanbanBoardRequestQueueActive());
  if (!active) return;

  const cb = active.callback;

  let promise = new Promise(
    resolve =>
      (active.callback = function(result) {
        resolve();
        cb?.(result);
      }),
  );

  yield put(active);

  yield promise;

  yield put({
    type: REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE,
  });
}

function* getKanbanBoards() {
  let boards = yield select(selectKanbanBoards());
  if (!boards || !boards.length) yield put(fetchKanbanBoards());
}

function* prepareProgressBar({ targetType, target, boardId }) {
  let boards = yield select(selectKanbanBoards());

  if (!boards || !boards.length) {
    //fetch the boards
    yield call(getMy, fetchKanbanBoards());
    boards = yield select(selectKanbanBoards());
  }

  if (!boards?.length) {
    return;
  }

  try {
    //   //calc progress for type ...
    const board = boards.find(b => b?.id == boardId) || boards[Object.keys(boards)[0]];

    if (!board) debugger;

    const numColumns = board.columns.length;
    let progress = -1;
    for (let i = 0; i < numColumns; i++) {
      try {
        let columns = yield call(getMy, fetchKanbanBoardColumnCells(board.id, board.columns[i].id));
        let t = columns.cells.find(c => c[targetType].id == target.id);
        if (t) progress = i / numColumns;
      } catch (e) {
        ///
      }
    }

    yield put(setProgressBarValue(boardId, targetType, target.id, progress));
  } catch (error) {
    console.dir(error);
    // /debugger;
  }
}

function* requestKanbanColumnCellsCheck({ boardId, columnId }) {
  let dirty = yield select(selectKanbanBoardColumnDirty(boardId, columnId));
  const key = `${boardId}_${columnId}`;
  if (!dirty) {
    columnRefetchRetries[key] = 0;
    return;
  }

  const current = columnRefetchRetries[key] || 0;
  const maxTries = 5;
  if (current >= maxTries) return;

  const next = current + 1;
  columnRefetchRetries[key] = next;

  const baseDelay = 2000;
  const delayMs = Math.min(baseDelay * Math.pow(2, next - 1), 30000);

  yield new Promise(resolve => setTimeout(resolve, delayMs));
  yield put(fetchKanbanBoardColumnCells(boardId, columnId));
}

function* requestKanbanColumnCellsPreFilter({ boardId, columnId, callback }) {
  let filter = yield select(selectKanbanFilter());
  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString || null;
  const sortType = filter?.sortType;
  const order = filter?.order;

  const filters = filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f));
  let filterString = '';
  for (let i = 0; i < filters?.length; i++) {
    filterString += `&filters[${i}][key]=${filters[i].key}&filters[${i}][type]=single&filters[${i}][value][0]=${filters[i].value[0]}`;
  }
  // change if use offset or limit first
  if (text) filterString += `&text=${text}`;
  filterString = '?' + filterString.slice(1);

  yield put(fetchKanbanBoardColumnCellsFiltered(boardId, columnId, filterString, callback));
}

export function* kanbanBoardSaga() {
  yield all([takeEvery(KANBAN_BOARDS_REFRESH, refreshBoards)]);
  yield all([takeEvery(GET_KANBAN_BOARDS, getKanbanBoards)]);
  yield all([takeEvery(PREPARE_KANBAN_PROGRESS_BAR, prepareProgressBar)]);
  yield all([
    takeEvery(REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS, requestKanbanColumnCells),
    takeEvery(APPLY_KANBAN_FILTERS, requestKanbanFilter),
    takeEvery(RESET_ALL_KANBAN_FILTERS, requestKanbanFilter),
  ]);
  yield all([takeEvery(REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_NEXT, requestKanbanColumnCellsNext)]);
  yield all([takeEvery(REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE, requestKanbanColumnCellsNext)]);
  yield all([takeEvery(REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD, requestKanbanColumnCellsNext)]);
  yield all([takeEvery(REQUEST_KANBAN_BOARD_COLUMN_CELLS_CHECK, requestKanbanColumnCellsCheck)]);
  yield all([takeEvery(REQUEST_KANBAN_BOARD_COLUMN_CELLS, requestKanbanColumnCellsPreFilter)]);
}
